import { render, staticRenderFns } from "./jobListDetail.vue?vue&type=template&id=6c2de4ec&scoped=true"
import script from "./jobListDetail.vue?vue&type=script&lang=js"
export * from "./jobListDetail.vue?vue&type=script&lang=js"
import style0 from "./jobListDetail.vue?vue&type=style&index=0&id=6c2de4ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2de4ec",
  null
  
)

export default component.exports